// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jhSy","type":"styles_type__3FUy3","choices":"styles_choices__1vV29"};